import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { usePlansDataStore } from '@store/plansStore';
import { numberWithCommas } from '@utils/comparationUtils';

import abaSegurosLogo from '@assets/images/aba.png';
import Vector from '@assets/images/priceAsset.svg';
import {
  useQuoteStore,
  useSelectedQuoteStore,
} from '../../../store/QuoteStore';

export const PriceDesktop = () => {
  const { selectedPlan, paymentMode } = usePlansDataStore();
  const { selectedQuote } = useSelectedQuoteStore();
  const [totalPayment, setTotalPayment] = useState<string>('');

  let position = 0
  
  if(selectedQuote.package === "AMP"){
    position = 0
  }
  if(selectedQuote.package === "LIMIT"){
    position = 1
  }
  if(selectedQuote.package === "RC"){
    position = 2
  }

  useEffect(() => {
    let totalNumber = 0;
    selectedQuote.available_packages[position].receipts.map((item: any) => {
      const number = Number(item?.total_premium);
      totalNumber += number;
    });
    setTotalPayment(totalNumber.toString());
  }, []);
  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      borderRadius={2}
      marginTop="19px"
      paddingLeft="50px"
      paddingRight="50px"
    >
      <Box
        width={278}
        height={100}
        borderRadius={'10px 0 0 10px '}
        style={{ backgroundColor: '#ffffff' }}
      >
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
          height={100}
        >
          <Box
            component={'img'}
            src={selectedQuote.company_logo}
            alt={selectedQuote.company_name}
            sx={{
              width: '78%',
              height: '100%',
            }}
            style={{ objectFit: 'contain' }}
          />
        </Box>
      </Box>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        width={279}
        height={100}
        borderRadius={'0 10px 10px 0'}
        style={{
          backgroundColor: '#ffffff',
          position: 'relative',
        }}
      >
        <Box
          component={'img'}
          src={Vector}
          style={{
            position: 'absolute',
            top: 'calc(50% - 15.85px)',
            left: '0px',
          }}
        />
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'start'}
          padding={1}
        >
          <Typography variant="subtitle2" color="#212121" fontSize={16}>
            Total a pagar
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ fontWeight: 'bold' }}
            fontSize={28}
          >
            $
            {parseFloat(parseFloat(totalPayment).toFixed(2)).toLocaleString(
              'es-MX',
              { minimumFractionDigits: 2 }
            )}
          </Typography>
          <Typography fontSize={12} style={{ color: '#8F8F8F' }}>Costo anual</Typography>
        </Box>
      </Box>
    </Box>
  );
};
